import React from 'react'
import {useMutation} from '@tanstack/react-query'
import {ID} from '../../_metronic/helpers'

export const DeleteModal = ({
  showDeleteConfirm,
  setShowDeleteConfirm,
  deleteAction,
  refetch,
  id,
}: {
  showDeleteConfirm: boolean
  setShowDeleteConfirm: (show: boolean) => void
  deleteAction?: (id: ID) => Promise<void>
  refetch?: () => void
  id: ID
}) => {
  const deleteItem = useMutation(() => deleteAction?.(id) || Promise.resolve(), {
    onSuccess: () => {
      setShowDeleteConfirm(false)
      refetch?.()
    },
  })

  if (!showDeleteConfirm) return null

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50'>
      <div className='bg-white  rounded-xl shadow-lg w-full max-w-md mx-auto p-6 relative'>
        <button
          className='absolute top-4 right-4 text-gray-400 hover:text-gray-600'
          onClick={() => setShowDeleteConfirm(false)}
          aria-label='Close'
        >
          &times;
        </button>

        <h3 className='text-lg md-4 flex justify-center font-semibold text-gray-800 mb-3'>
          Confirm Deletion
        </h3>
        <p className='flex justify-center text-md py-6 text-gray-600 mb-6'>
          Are you sure you want to delete this record?
        </p>

        <div className='flex justify-center gap-3'>
          <button
            type='button'
            className='px-4 py-2 rounded-md bg-gray-100 hover:bg-gray-200 text-sm font-medium text-gray-700'
            onClick={() => setShowDeleteConfirm(false)}
          >
            Cancel
          </button>
          <button
            type='button'
            className='px-4 py-2 rounded-md bg-red-600 hover:bg-red-700 text-white text-sm font-semibold disabled:opacity-60'
            onClick={() => deleteItem.mutate()}
            disabled={deleteItem.isLoading}
          >
            {/* <Trash2 className='w-4 h-4 text-red-500 ml-2' /> */}
            {deleteItem.isLoading ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  )
}
